/** Module-level ref to the DOM node in the PSP header reserved for remote app portal content.
 *  Header.tsx sets this via a callback ref; createShellBridge reads it via a getter.
 *
 *  TODO: Handle header remount (error boundary reset, Suspense re-mount). When Header
 *  remounts, the callback ref fires with a new DOM node, but apps that already called
 *  requestHeaderSlot() are portaled into the old (detached) node and their UI silently
 *  disappears. Two viable fixes when this becomes real:
 *    (a) Return a stable wrapper element the shell re-parents on remount.
 *    (b) Emit a `headerSlotChanged` shell event so apps can re-portal.
 *  Not blocking for dev+integration experimental scope (contract v0.2.0). */
export const headerActionSlotRef: { current: HTMLElement | null } = { current: null };
